import { render, staticRenderFns } from "./ValidationErrorTips.vue?vue&type=template&id=d4e01fd8&scoped=true&lang=pug"
import script from "./ValidationErrorTips.vue?vue&type=script&lang=js"
export * from "./ValidationErrorTips.vue?vue&type=script&lang=js"
import style0 from "./ValidationErrorTips.vue?vue&type=style&index=0&id=d4e01fd8&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4e01fd8",
  null
  
)

export default component.exports